/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { StoreDaypartResult } from '../../models/store-daypart-result';

export interface StoresStoreIdDaypartsGet$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
}

export function storesStoreIdDaypartsGet(http: HttpClient, rootUrl: string, params: StoresStoreIdDaypartsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<StoreDaypartResult>;
};
}>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdDaypartsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      '_embedded'?: {
      'dayparts'?: Array<StoreDaypartResult>;
      };
      }>;
    })
  );
}

storesStoreIdDaypartsGet.PATH = '/stores/{storeId}/dayparts';
